import { TableCell, TableCellProps, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { TooltipHeaderTitle } from "../styled";

export default function Header({
  item,
  align = "center",
  withTooltip = false,
}: {
  item: string;
  align?: TableCellProps["align"];
  withTooltip?: boolean;
}) {
  const { t } = useTranslation(["stats", "rules"]);

  if (withTooltip)
    return (
      <TableCell key={item} align={align}>
        <Tooltip title={t(`rules:mailboxStats.headerTooltip.${item}`)}>
          <TooltipHeaderTitle color="primary">
            {t(`accounts.accountsTable.header.${item}`)}
          </TooltipHeaderTitle>
        </Tooltip>
      </TableCell>
    );

  return (
    <TableCell key={item} align={align}>
      {t(`accounts.accountsTable.header.${item}`)}
    </TableCell>
  );
}
